/**
 * Typed environment — validated at build time by the Vite plugin in vite.config.ts.
 * Zod schema lives in env.schema.ts and is NOT shipped to the client.
 */
import type { Env } from './env.schema'

export type { Env } from './env.schema'

export const env: Env = import.meta.env as unknown as Env
